import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";
import { StatePill } from "./StatePill";

const SECTIONS = [
  ["coach_alerts", "Avisos de plazo sin leer"], ["needs_review", "Resultados pendientes de revisión"], ["videos", "Vídeos pendientes de revisar"],
  ["overdue", "No han completado la prueba (fecha pasada)"], ["repeat", "Tests que deben repetirse"], ["upcoming", "Evaluaciones próximas (14 días)"],
  ["pending", "Tests pendientes por futbolista"], ["changes", "Mejoras y empeoramientos reales"], ["setup", "Fichas incompletas (no se pueden realizar)"],
];
const link = (cid) => `/app/admin/clients/${cid}?tab=evaluaciones`;
const when = (d) => (d > 0 ? `en ${d} d` : d === 0 ? "hoy" : `hace ${-d} d`);

const Row = ({ k, it, onRead }) => {
  if (k === "coach_alerts") return (
    <div style={rowS} data-testid={`ov-alert-${it.id}`}><Link to={link(it.user_id)} style={{ ...a, fontWeight: 400 }}>{it.message}</Link>
      <button className="qv-btn-ghost" style={{ padding: "4px 8px", fontSize: 11 }} onClick={() => onRead(it.id)} data-testid={`ov-alert-read-${it.id}`}>Marcar leído</button></div>
  );
  if (k === "videos") return <div style={rowS} data-testid={`ov-video-${it.id}`}><span><Link to={link(it.client_id)} style={a}>{it.client_name}</Link> · {it.test} · {it.date}</span><span style={{ fontSize: 11, color: "#60a5fa" }}>{it.status === "submitted" ? "con resultado por revisar" : "resultado validado"}</span></div>;
  if (k === "changes") return (
    <div style={rowS} data-testid={`ov-change-${it.client_id}-${it.test}`}><span><Link to={link(it.client_id)} style={a}>{it.client_name}</Link> · {it.test}: {it.previous} → {it.current} {it.unit || ""}</span>
      <span style={{ fontSize: 12, fontWeight: 700, color: it.verdict === "better" ? "#4ade80" : "#f87171" }}>{it.verdict === "better" ? "Mejora" : "Empeora"} ({it.diff > 0 ? "+" : ""}{it.diff}{it.pct !== undefined && it.pct !== null ? ` · ${it.pct > 0 ? "+" : ""}${it.pct} %` : ""})</span></div>
  );
  return (
    <div style={rowS} data-testid={`ov-${k}-${it.id}`}>
      <span><Link to={link(it.client_id)} style={a}>{it.client_name}</Link> · {it.test} · {it.due_date} ({when(it.days)}){it.beyond_grace ? <b style={{ color: "#f87171" }}> · fuera de plazo</b> : ""}{it.repeat_comment ? <span style={{ color: "#a3a3a3" }}> · «{it.repeat_comment}»</span> : ""}</span>
      <StatePill s={it.state} />
    </div>
  );
};
const SetupSection = ({ items }) => {
  const by = {};
  items.forEach((it) => { (by[it.template_id] = by[it.template_id] || { test: it.test, players: new Set() }).players.add(it.client_name); });
  return (
    <details id="ov-setup" className="qv-card-app" style={{ padding: 16, marginBottom: 12 }} data-testid="ov-section-setup">
      <summary style={{ fontWeight: 800, cursor: "pointer" }}>Fichas incompletas: {Object.keys(by).length} fichas · {items.length} asignaciones no se pueden realizar todavía</summary>
      <div style={{ fontSize: 12, color: "#a3a3a3", margin: "6px 0" }}>Complétalas en la pestaña Biblioteca para que el futbolista pueda hacerlas y empiecen los recordatorios.</div>
      {Object.entries(by).map(([tid, g]) => <div key={tid} style={rowS} data-testid={`ov-setup-${tid}`}><b>{g.test}</b><span style={{ color: "#a3a3a3" }}>{g.players.size} futbolista(s): {[...g.players].join(", ")}</span></div>)}
    </details>
  );
};
const rowS = { display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap", alignItems: "center", padding: "7px 0", borderTop: "1px solid rgba(255,255,255,0.06)", fontSize: 13 };
const a = { color: "#fff", fontWeight: 700, textDecoration: "none" };

export const OverviewTab = () => {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/admin/tests-overview").then((r) => setD(r.data)).catch((e) => toast.error(formatErr(e))), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return <div style={{ color: "#a3a3a3" }}>Cargando…</div>;
  const read = (id) => {
    const rest = d.coach_alerts.filter((x) => x.id !== id);
    setD({ ...d, coach_alerts: rest, counts: { ...d.counts, coach_alerts: rest.length } });
    api.post(`/admin/test-notices/${id}/read`).catch((e) => { toast.error(formatErr(e)); load(); });
  };
  return (
    <div data-testid="ov-tab">
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
        {SECTIONS.map(([k, l]) => (
          <a key={k} href={`#ov-${k}`} className="qv-card-app" style={{ padding: "10px 14px", textDecoration: "none", color: "#fff", minWidth: 130 }} data-testid={`ov-count-${k}`}>
            <div style={{ fontSize: 22, fontWeight: 800, color: d.counts[k] ? "#fff" : "#525252" }}>{d.counts[k]}</div><div style={{ fontSize: 11, color: "#a3a3a3" }}>{l}</div>
          </a>
        ))}
      </div>
      {SECTIONS.filter(([k]) => d[k].length && k !== "setup").map(([k, l]) => (
        <div key={k} id={`ov-${k}`} className="qv-card-app" style={{ padding: 16, marginBottom: 12 }} data-testid={`ov-section-${k}`}>
          <div style={{ fontWeight: 800, marginBottom: 4 }}>{l}</div>
          {(k === "pending" ? [...d[k]].sort((x, y) => (x.client_name || "").localeCompare(y.client_name || "")) : d[k]).map((it, i) => <Row key={it.id || i} k={k} it={it} onRead={read} />)}
        </div>
      ))}
      {d.setup.length > 0 && <SetupSection items={d.setup} />}
      {SECTIONS.every(([k]) => !d[k].length) && <div className="qv-empty" data-testid="ov-empty">No hay nada pendiente.</div>}
    </div>
  );
};
